import { useSimpleFeatureTernary } from "@viagogo/feature";
import { FeatureSetEnum } from "src/shared/constants/FeatureSetEnum";
import {
  skeletonCard,
  skeletonCardImage,
  skeletonCardImageLegacy,
  skeletonCardImageMedium4x3,
  skeletonCardLegacy,
  skeletonCardLine,
  skeletonCardMedium4x3,
  skeletonCardsRow,
  skeletonCardsRowLegacy,
  skeletonContainer,
  skeletonTitle,
} from "./carousel-skeleton.recipes";

const SKELETON_CARD_COUNT = 4;

interface CarouselSkeletonProps {
  variant?: "regular" | "medium4x3";
}

export const CarouselSkeleton = ({ variant = "regular" }: CarouselSkeletonProps) => {
  const useImprovedSkeleton = useSimpleFeatureTernary(FeatureSetEnum.DiscoveryImprovedLoadingSkeleton, false, true);

  let cardClass: string;
  let imageClass: string;
  let rowClass: string;

  if (variant === "medium4x3") {
    cardClass = skeletonCardMedium4x3;
    imageClass = skeletonCardImageMedium4x3;
    rowClass = skeletonCardsRow;
  } else if (useImprovedSkeleton) {
    cardClass = skeletonCard;
    imageClass = skeletonCardImage;
    rowClass = skeletonCardsRow;
  } else {
    cardClass = skeletonCardLegacy;
    imageClass = skeletonCardImageLegacy;
    rowClass = skeletonCardsRowLegacy;
  }

  return (
    <div className={skeletonContainer} aria-hidden="true">
      <div className={skeletonTitle} />
      <div className={rowClass}>
        {Array.from({ length: SKELETON_CARD_COUNT }, (_, index) => index).map((cardIndex) => (
          <div className={cardClass} key={`skeleton-card-${cardIndex}`}>
            <div className={imageClass} />
            <div className={skeletonCardLine} />
            <div className={skeletonCardLine} style={{ width: "70%" }} />
            <div className={skeletonCardLine} style={{ width: "50%" }} />
          </div>
        ))}
      </div>
    </div>
  );
};
